module.exports = "<h1>Page Not Found!</h1>\n<p>\n    There is nothing here! :-(\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/clientpanel/src/app/components/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/components/page-not-found/page-not-found.component.html
// module chunks = main